import React, { useCallback } from "react";
import "./componentStyles/TimesheetCalendar.css";

function formatMonthTitle(monthStr) {
  // monthStr: YYYY-MM
  try {
    const [y, m] = monthStr.split("-").map(n => parseInt(n, 10));
    const dt = new Date(y, m - 1, 1);
    const title = dt.toLocaleString("tr-TR", { month: "long", year: "numeric" });
    // İlk harfi büyük
    return title.charAt(0).toUpperCase() + title.slice(1);
  } catch {
    return monthStr;
  }
}

function formatDateTR(dateStr) {
  // dateStr: YYYY-MM-DD -> 01.05.2024 Çarşamba
  try {
    const [y, m, d] = dateStr.split("-").map(n => parseInt(n, 10));
    const dt = new Date(y, m - 1, d);
    const day = String(d).padStart(2, "0");
    const mon = String(m).padStart(2, "0");
    const dow = dt.toLocaleString("tr-TR", { weekday: "long" });
    return `${day}.${mon}.${y} ${dow.charAt(0).toUpperCase() + dow.slice(1)}`;
  } catch {
    return dateStr;
  }
}

const hourLabels = [
  "09.00 - 10.00",
  "10.00 - 11.00",
  "11.00 - 12.00",
  "13.00 - 14.00",
  "14.00 - 15.00",
  "15.00 - 16.00",
  "16.00 - 17.00",
];

// ✅ NEW: Helper to check if date is in the future
const isFutureDate = (dateStr) => {
  try {
    const [y, m, d] = dateStr.split("-").map(n => parseInt(n, 10));
    const targetDate = new Date(y, m - 1, d);
    targetDate.setHours(0, 0, 0, 0); // Start of day
    
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Start of today
    
    return targetDate > today;
  } catch {
    return false;
  }
};

function TimesheetCalendar({ employment, timesheet, loading, onToggleHour, editMode }) {
  const handleToggle = useCallback((date, idx) => {
    if (!editMode) return;
    // ✅ FIX: Gelecek tarihlerde değişiklik yapılmasını engelle
    if (isFutureDate(date)) {
      return; // Sessizce engelle
    }
    onToggleHour?.(date, idx);
  }, [editMode, onToggleHour]);

  const onCellKeyDown = (e, date, idx) => {
    if (!editMode) return;
    // ✅ FIX: Gelecek tarihlerde değişiklik yapılmasını engelle
    if (isFutureDate(date)) return;
    
    if (e.key === "Enter") {
      e.preventDefault();
      handleToggle(date, idx);
    }
  };

  if (!employment) return <div className="tsc-muted">Aktif part-time kaydınız bulunamadı.</div>;
  if (loading) return <div className="tsc-muted">Yükleniyor...</div>;
  if (!timesheet) return <div className="tsc-muted">Takvim alınamadı.</div>;

  return (
    <div className="tsc-wrapper">
      <div className="tsc-namebar">{employment.studentName || ""}</div>
      <div className="tsc-table-wrap">
        <table className="tsc-table">
          <thead>
            <tr>
              <th className="tsc-col-date">{formatMonthTitle(timesheet.month)}</th>
              {hourLabels.map((h, i) => (
                <th key={i} className="tsc-col-hour">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(timesheet.days || []).map((d) => {
              // ✅ NEW: Check if this row is a future date
              const isFuture = isFutureDate(d.date);
              
              return (
                <tr key={d.date} className={isFuture ? "tsc-row-future" : ""}>
                  <td className="tsc-date-cell">{formatDateTR(d.date)}</td>
                  {(d.hours || []).map((v, idx) => (
                    <td key={idx} className="tsc-slot-cell">
                      {editMode ? (
                        <button
                          type="button"
                          className={`tsc-plus ${v ? "on" : "off"} ${isFuture ? "disabled" : ""}`}
                          onClick={() => handleToggle(d.date, idx)}
                          onKeyDown={(e) => onCellKeyDown(e, d.date, idx)}
                          tabIndex={isFuture ? -1 : 0} // ✅ Gelecek tarihler klavye ile erişilemez
                          aria-pressed={!!v}
                          aria-disabled={isFuture} // ✅ Ekran okuyucular için
                          disabled={isFuture} // ✅ Native HTML disabled
                          title={isFuture ? "Gelecek tarih düzenlenemez" : (v ? "Seçili" : "Seç")}
                        >
                          +
                        </button>
                      ) : (
                        v ? (
                          <span className="tsc-mark" title="Seçili">+</span>
                        ) : (
                          <span className="tsc-cell-empty" aria-hidden="true"></span>
                        )
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="tsc-note">
        Not: Her satır hafta içi bir günü temsil eder. Düzenle'ye bastıktan sonra <strong>bugün ve geçmiş günlerdeki</strong> hücrelerdeki "+" işaretine tıklayabilir veya odaktayken Enter'a basarak saat seçebilirsiniz.
      </div>
    </div>
  );
}

export default TimesheetCalendar;